// clarity.service.ts
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { sha256 } from '../util/hash.util';
import { CookieConsentService } from './cookie-consent.service';

@Injectable({
  providedIn: 'root',
})
export class ClarityService {
  private lastTrackedUserId: number | null = null;

  constructor(private readonly cookieConsentService: CookieConsentService) {}

  async trackUser(user: {
    userId: number;
    email: string;
    phoneNumber: string;
  }): Promise<void> {
    if (!this.canTrackUser() || this.lastTrackedUserId === user.userId) {
      return;
    }

    const [hashedEmail, hashedPhone] = await Promise.all([
      sha256(user.email),
      sha256(user.phoneNumber),
    ]);

    // Consent can change while the hashes are being calculated. A saved
    // preference change reloads the page, but this second check also prevents
    // a queued identification call from racing that reload.
    if (!this.canTrackUser()) {
      return;
    }

    window.clarity?.('set', 'user_id', user.userId);
    window.clarity?.('set', 'user_email_hash', hashedEmail);
    window.clarity?.('set', 'user_phone_hash', hashedPhone);

    this.lastTrackedUserId = user.userId;
  }

  private canTrackUser(): boolean {
    const consent = this.cookieConsentService.snapshot;

    return Boolean(
      environment.production &&
        environment.analyticsEnabled &&
        consent.hasSavedPreference &&
        consent.preferences.microsoftClarity &&
        typeof window.clarity === 'function'
    );
  }
}
